/**
 * Situacao de um aviso, derivada das datas e do cancelamento. Mora aqui para a
 * listagem (chip, filtro, lapis) e a tela de edicao nao discordarem.
 *
 * A chave tambem e o valor do filtro "Situacao" na URL da listagem.
 */
export const BROADCAST_STATUS_LABELS = {
  agendada: 'Agendada',
  'no-ar': 'No ar',
  encerrada: 'Encerrada',
  cancelada: 'Cancelada',
};

export const broadcastStatusKey = (item, now) => {
  const at = now || new Date();
  if (item.cancelledAt) return 'cancelada';
  if (item.endsAt && new Date(item.endsAt) < at) return 'encerrada';
  if (new Date(item.startsAt) > at) return 'agendada';
  return 'no-ar';
};

/**
 * Aviso cancelado ou encerrado nao se edita mais: nao volta a aparecer para
 * ninguem, e mexer no texto so reescreveria o historico do que foi mostrado.
 * Devolve o motivo, ou '' quando pode editar.
 */
export const lockedReason = (item, now) => {
  const key = broadcastStatusKey(item, now);
  if (key === 'cancelada') return 'Aviso cancelado não pode ser editado.';
  if (key === 'encerrada') return 'Aviso encerrado não pode ser editado.';
  return '';
};



// WEBPACK FOOTER //
// ./src/vue/pages/restricted/broadcast/broadcastStatus.js